import { createSelector } from "reselect";
import _ from "lodash";
import dateUtil from "../common/date/dateUtil";

const incidentPriorityFilterSelector = state => state.incidentPriorityFilter;
const incidentStatusFilterSelector = state => state.incidentStatusFilter;
const incidentSearchFilterSelector = state => state.incidentSearchFilter;
const logIncidentSelector = state => state.logIncident;
const errorsSelector = state => state.incidentErrors;

export const getPriorityFilter = createSelector(
  incidentPriorityFilterSelector,
  logIncidentSelector,
  (incidentPriorityFilter, logIncident) => {
    const incidentLabels = _.groupBy(
        logIncident,
        logIncident => logIncident.Priority
    );

    const filters = Object.keys(incidentLabels).map(key => {
      const isSelected =
          incidentPriorityFilter.filter(pf => pf === key).length > 0;
      return { key, isSelected };
    });
    return _.sortBy(filters, filters => filters.key);
  }
);

export const getStatusFilter = createSelector(
    incidentStatusFilterSelector,
    logIncidentSelector,
    (incidentStatusFilter, logIncident) => {
        const incidentLabels = _.groupBy(
            logIncident,
            logIncident => logIncident.Status
        );

        const filters = Object.keys(incidentLabels).map(key => {
            const isSelected =
                incidentStatusFilter.filter(sf => sf === key).length > 0;
            return { key, isSelected };
        });
        return _.orderBy(filters, filters => filters.key, "desc");
    }
);

export const getVisibileIncidents = createSelector(
    incidentPriorityFilterSelector,
    incidentStatusFilterSelector,
    incidentSearchFilterSelector,
    logIncidentSelector,
    (incidentPriorityFilter, statusFilter,incidentSearchFilter, logIncident) => {
        const hasNoSelectedPriorityFilter = incidentPriorityFilter.length === 0;
        const hasNoSelectedStatusFilter = statusFilter.length === 0;

      return logIncident.reduce(
          (result, incident) => {
              if ((incidentPriorityFilter.some(sf => sf == incident.Priority) || hasNoSelectedPriorityFilter) &&
                  (statusFilter.some(sf => sf == incident.Status) || hasNoSelectedStatusFilter)) {
                  const cropSize = 50;
                  const shouldCrop = incident.Subject.length > cropSize;

                  result.push({
                      id: incident.Id,
                      priority: incident.Priority,
                      date: dateUtil.toYearMonthAndDay(incident.Date),
                      status: incident.Status,
                      subject: shouldCrop
                          ? `${incident.Subject.substring(0, cropSize)}...`
                          : incident.Subject,
                      comments: incident.Comments,
                      actionTaken: incident.LatestComment.CommentType
                  });
              }
              return _.filter(result, o => _.includes(JSON.stringify(o).toLowerCase(), incidentSearchFilter.toLowerCase()));
          }, []
      );
  }
);

export const getIncidentsHasErrors = createSelector(errorsSelector, errors => {
  return errors.length > 0;
});



// WEBPACK FOOTER //
// ./src/incidents/incidentSelector.js